// extracted by mini-css-extract-plugin
export default {"root":"style_root__w3nd9","loader":"style_loader__f2XfF","load8":"style_load8__EF77a"};